<div class="userCard mat-elevation-z2">
    <div class="userMenuChip">
        <mat-icon *ngIf="!userImage" class="userMenuChip__ico">account_circle</mat-icon>
        <img *ngIf="userImage" #userPic src="{{_persona.imageUrl}}" class="userMenuChip__img">
        <div *ngIf="_persona">
            <span class="userMenuChip__user">{{_persona.nombresApellidos}}</span>
            <span class="userMenuChip__otherInfo">{{_persona.eMail}}</span>
        </div>
    </div>
    <div class="alumnoFicha__content">
        <p *ngIf="_persona && _persona.curso"><strong>Curso:</strong> {{_persona.curso.nickName}}</p>
        <p *ngFor="let link of links">
            <a [routerLink]="link.path">{{ link.text }}</a>
        </p>
    </div>
</div>
